export const SAVE_LOCAL_STORAGE_VALUE = "SAVE_LOCAL_STORAGE_VALUE"
export const CLEAR_LOCAL_STORAGE_VALUE = "CLEAR_LOCAL_STORAGE_VALUE"
